import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Music4: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M9 18V5l12-2v13' }],
    ['path', { d: 'm9 9 12-2' }],
    ['circle', { cx: '6', cy: '18', r: '3' }],
    ['circle', { cx: '18', cy: '16', r: '3' }],
  ],
];

export default Music4;
